/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useEffect, useState } from "react";

import DataGridPica from "../../components/PantallesBKI/DataGridMui/DataGrid";
import { columnsLogsEnviamentsPRE } from "../../components/PantallesBKI/DataGridMui/Columns/Columns";
import { ToolbarLogsEnviaments } from "../../components/PantallesBKI/DataGridMui/CustomToolbar/CustomToolbar";
import CircularProgress from "@mui/material/CircularProgress";
import { URL_BKI } from "../../constants/URL";

/*MENSAJES DE ALERTA*/
import ErrorAlert from "../../components/PantallesBKI/Alertas/ErrorAlert";
import { getAuthToken } from "../../security/tokenUtils";

function TablaLogsEnviamentsView() {
  const [token] = useState(getAuthToken());

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getData = () => {
    fetch(URL_BKI.GET_LOGS_EVIAMENTS, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        setData(myJson);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          `Ha ocurrido un error al pedir el recurso. Error: ${error.message}`
        );

        ErrorAlert("ERROR " + error);

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="w-100, boxPantalla">
      <h2>Taula de enviaments XML</h2>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <DataGridPica
          ampleTaula="90%"
          data={data}
          sortModel={[
            {
              field: "ENV_DATA_ALTA_FITXER",
              sort: "desc",
            },
          ]}
          density="compact"
          rowHeight={90}
          col={columnsLogsEnviamentsPRE}
          rowId={(row) => row.ENV_ID}
          components={{ Toolbar: ToolbarLogsEnviaments }}
        />
      )}
    </div>
  );
}
export default TablaLogsEnviamentsView;
